var TabsSlider = /** @class */ (function () {
    function TabsSlider(tabsSlider, tabsNav) {
        this.resizeTimeout = 0;
        this.tabsSlider = tabsSlider;
        this.tabsNav = tabsNav;
        this.setSliderStyle();
        this.bindEvents();
    }
    TabsSlider.prototype.bindEvents = function () {
        var _this = this;
        window.addEventListener('resize', function () { _this.onResize(); });
    };
    TabsSlider.prototype.onResize = function () {
        var _this = this;
        window.clearTimeout(this.resizeTimeout);
        this.resizeTimeout = window.setTimeout(function () {
            _this.setSliderStyle();
        }, 300);
    };
    TabsSlider.prototype.getOffset = function (target) {
        var activeTabElement = target ? target : this.tabsNav.querySelector('.is-active');
        var offset = {
            left: 0,
            width: 0
        };
        if (activeTabElement) {
            offset = {
                left: activeTabElement.getBoundingClientRect().left - this.tabsNav.getBoundingClientRect().left,
                width: activeTabElement.getBoundingClientRect().width,
            };
        }
        return offset;
    };
    TabsSlider.prototype.setSliderStyle = function (target) {
        var offset = this.getOffset(target);
        this.tabsSlider.setAttribute('style', 'width: ' + offset.width + 'px; left: ' + offset.left + 'px;');
    };
    return TabsSlider;
}());
export default TabsSlider;
